module.exports = __webpack_public_path__ + "img/img-11.aff44a83.webp";